import Prism from 'prismjs';

Prism.highlightAll();
